export default "__VITE_ASSET__BLZkvj$f__"